import {ObjectDTO} from "./object-dto";

export class UniteDeProduction__LivraisonDTO extends ObjectDTO {

  idSecteurFournisseur : number;
  idUdpSecteurFournisseur: number;
  numeroJourSemaine : number;

  //udp secteur fournisseur
  codeClient : string;
  delaiLivraisonHeureLimite:Date;
  delaiLivraisonJours:number;
  remarqueCommande: string;



  //transient
  actif:boolean=true;

}
